import { render, staticRenderFns } from "./GamiRewards.vue?vue&type=template&id=08c0d766&scoped=true"
import script from "./GamiRewards.vue?vue&type=script&lang=js"
export * from "./GamiRewards.vue?vue&type=script&lang=js"
import style0 from "./GamiRewards.vue?vue&type=style&index=0&id=08c0d766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0d766",
  null
  
)

export default component.exports